import {Controller} from "./helpers/controller";
import {centerListing, findCenterControl} from "./findCenterControl";
import {TabControl as tabControl} from "./tabControl";
import {shim} from "./helpers/shim";
import {CarouselControl} from "./carouselControl";

export class ProductPricingFindACentreControl extends Controller {
    private centerListing?: centerListing;
    private findCenter?: findCenterControl;
    private rootElement: JQuery;
    public carouselControls: Array<CarouselControl> = [];
    private centreContainer: JQuery;
    
    constructor(element: HTMLElement) {
        super(element);

        this.rootElement = $(element);
        this.centreContainer = this.rootElement.find('#inCentre');
        
        // attach find a centre form
        if (this.rootElement.find('[data-product-pricing-find-a-centre-form]').length > 0) {
            let findForm = this.rootElement.find('[data-product-pricing-find-a-centre-form]')[0];
            this.findCenter = new findCenterControl(findForm, false, this.centerSelect, this.onlineSelect);
        }

        // carousels
        this.rootElement.find('[data-carousel-pricing]').each((index: number, element: Element) => {
            this.carouselControls.push(new CarouselControl(element as HTMLElement));
        })
        
        // online / centre tabs
        this.rootElement.find('[data-tabs-pricing]').each((index: number, element: Element) => {
            new tabControl(element as HTMLElement,
                {
                    tabSelectedClass: 'selected',
                    selectedDiv: '',
                    callback: () => {
                        this.carouselControls.forEach((carousel) => {
                            carousel.reloadFlickity();
                        });
                        
                        this.updateDisplayOfMonthlySessionToggleSwitch();
                    }
                });
        });
        
        // monthly / session toggle
        this.rootElement.find("#pricing-session-monthly").each((index: number, element: Element) => {
            (element as HTMLInputElement).addEventListener("change", (changeEvent) => {
                this.updateDisplayOfSessionMonthlyPrices();
            });
        })

        // edit centre button
        this.rootElement.find('[data-pricing-edit-centre]').on('click', (element: any) => {
            this.updateCentreId("");
            
            element.preventDefault();
        })

        if (($($('[data-pricing-centre-locked]')[0]).attr('data-pricing-centre-locked') == 'true')) {
            this.rootElement.find("#centreTab")[0].click()
        }

        this.rootElement.find('[data-pricing-book-button]').on('click', (element: any) => {
            element.preventDefault();

            let productId = element.currentTarget.getAttribute('data-pricing-book-button-product-id');
            let centre = this.centreContainer.attr("data-pricing-centre-id");
            let productIndex = element.currentTarget.getAttribute('data-pricing-book-button-product');
            let variant = $(`input[name = "product${productIndex}"]:checked`).val();

            document.location.href = `/membership/signup/getstarted?c=${centre ?? ''}&p=${productId}&v=${variant}`;
        });
    }
    
    updateDisplayOfSessionMonthlyPrices = () => {
        let checkbox = (this.rootElement.find("#pricing-session-monthly")[0] as HTMLInputElement);
                
        // all pricing cards
        let productCards = this.rootElement.find('[data-pricing-card-product-id]');
        for (let productIndex: number = 0; productIndex < productCards.length; productIndex++) {
            let productCard = $(productCards[productIndex]);
            let productCardVariants = productCard.find('label.priceRadio');
            for (let productVariantIndex: number = 0; productVariantIndex < productCardVariants.length; productVariantIndex++) {
                let productCardVariant = $(productCardVariants[productVariantIndex]);
                
                let monthly = productCardVariant.find('[data-pricing-monthly]');
                
                let monthlyCost = $(monthly[1]);
                let monthlyCostValue = monthlyCost.find('.costPrice').text();
                
                let monthlyOldCost = $(monthly[0]);
                let monthlyOldCostValue = monthlyOldCost.find('.costPrice').text();
                
                let session = productCardVariant.find('[data-pricing-session]');
                
                let sessionCost = $(session[1]);
                let sessionCostValue = sessionCost.find('.costPrice').text();
                
                let sessionOldCost = $(session[0]);
                let sessionOldCostValue = sessionOldCost.find('.costPrice').text();

                if (checkbox.checked) {
                    sessionCost.show();
                    if (sessionCostValue == sessionOldCostValue) {
                        sessionOldCost.hide();
                    } else {
                        sessionOldCost.show();
                    }
                    
                    monthlyCost.hide();
                    monthlyOldCost.hide();
                } else {
                    sessionCost.hide();
                    sessionOldCost.hide();
                    monthlyCost.show();
                    if (monthlyCostValue == monthlyOldCostValue) {
                        monthlyOldCost.hide();
                    } else {
                        monthlyOldCost.show();
                    }
                }
            }
        }
        
    }

    updateCentreId = (centreId: string) => {
        this.centreContainer.attr("data-pricing-centre-id", centreId);

        this.updateDisplayOfCentreName();
        
        this.updateDisplayOfCentreSelector();

        this.updateDisplayOfMonthlySessionToggleSwitch();
        
        this.updateDisplayOfPriceCarousel();
        
        if (this.hasCentreBeenSet()) {
            this.updateCentrePricesFromApi();
        }
    }
    
    updateCentrePricesFromApi = () => {
        let centreId = this.getCentreId();
        
        let productId = this.getProductId();
        
        $.get( "/api/pricingapi/centre/?centreId=" + centreId + "&productId=" + productId, ( data: Array<any> ) => {
            for (let productIndex: number = 0; productIndex < data.length; productIndex++) {
                let productData = data[productIndex];
                let productIdToUpdate = productData.productId;

                let productCard = this.centreContainer.find('[data-pricing-card-product-id="' + productIdToUpdate + '"]');
                let productCardVariants = productCard.find('label.priceRadio');
                for (let productVariantIndex: number = 0; productVariantIndex < productCardVariants.length; productVariantIndex++)
                {
                    let productCardVariant = $(productCardVariants[productVariantIndex]);

                    let monthly = productCardVariant.find('[data-pricing-monthly]');
                    let session = productCardVariant.find('[data-pricing-session]');

                    let priceData = productData.variants[productVariantIndex].price;
                    
                    let monthlyCost = $(monthly[1]);
                    monthlyCost.find('.costPrice').text((Math.round(priceData.currentPrice * 100) / 100).toFixed(2));
                    
                    let monthlyOldCost = $(monthly[0]);
                    monthlyOldCost.find('.costPrice').text((Math.round(priceData.usualPrice * 100) / 100).toFixed(2));
                    
                    let sessionCost = $(session[1]);
                    sessionCost.find('.costPrice').text((Math.round(priceData.sessionCurrentPrice * 100) / 100).toFixed(2));
                    
                    let sessionOldCost = $(session[0]);
                    sessionOldCost.find('.costPrice').text((Math.round(priceData.sessionUsualPrice * 100) / 100).toFixed(2));

                    this.updateDisplayOfSessionMonthlyPrices();
                }
            }
        });
    }

    getCentreId = () => {
        return this.centreContainer.attr("data-pricing-centre-id");
    }
    
    getProductId = () => {
        return this.rootElement.attr("data-pricing-product-id");
    }
    
    hasCentreBeenSet = () => {
        return this.getCentreId().length > 0;
    }
    
    updateDisplayOfCentreName = () => {
        let centreNameContainer = this.centreContainer.find("#centreNameContainer");
        if (this.hasCentreBeenSet()) {
            centreNameContainer.show();
        } else {
            centreNameContainer.hide();
        }
    }
    
    updateDisplayOfPriceCarousel = () => {
        let priceCarousel = this.centreContainer.find(".priceCarousel");
        if (this.hasCentreBeenSet()) {
            priceCarousel.show();
        } else {
            priceCarousel.hide();
        }

        this.carouselControls.forEach((carousel) => {
            carousel.reloadFlickity();
        });
    }

    updateDisplayOfCentreSelector = () => {
        let centreNameContainer = this.centreContainer.find("#centreSelectorContainer");
        if (this.hasCentreBeenSet()) {
            centreNameContainer.hide();
        } else {
            centreNameContainer.show();
        }
    }
    
    updateDisplayOfMonthlySessionToggleSwitch = () => {
        let monthlySessionSwitch = this.rootElement.find("label.switch");
        
        if (!this.centreContainer.is(':visible')) {
            monthlySessionSwitch.show();
        } else {
            if (this.hasCentreBeenSet()) {
                monthlySessionSwitch.show();
            } else {
                // hide the session toggle if we haven't got a centre yet
                monthlySessionSwitch.hide();
            }
        }
    }
    
    centerSelect = (center: centerListing) =>{
        this.centerListing = center;
        if (this.findCenter == undefined) {
            return;
        }
        
        this.findCenter.close();

        this.updateCentreId(center.centerId);

        this.centreContainer.find("p.centrePicked").find("strong").text(center.name);
    }

    onlineSelect = () => {
        if (this.findCenter == undefined) {
            return;
        }
        
        this.findCenter.close();        
        
        this.rootElement.find("#onlineTab")[0].click()
    }
}